import {
  CheckboxChangeEvent,
  Checkbox as KendoCheckbox,
  CheckboxProps as KendoCheckboxProps,
} from '@progress/kendo-react-inputs';
import _ from 'lodash';
import React from 'react';
import { ValidationError } from '../../apps/benefit/models/Errors';
import ErrorViewer from './ErrorViewer';

export interface CustomCheckboxProps {
  label: string | any;
  isChecked: boolean;
  helper?: string;
  errors?: ValidationError[];
  mandatory?: boolean;
  clearErrors?: () => void;
  onLabelClick?: () => void;
}

export type CheckboxProps = KendoCheckboxProps & CustomCheckboxProps;

export default function Checkbox(props: CheckboxProps) {
  const {
    isChecked,
    errors,
    clearErrors,
    onChange,
    onLabelClick,
    helper,
    label,
    mandatory,
  } = props;
  const internalOnChange = (e: CheckboxChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };
  const mandatoryElement = mandatory ? `<sup>*</sup>` : '';
  const classNames = `form-checkbox ${
    errors?.length ? 'has-error' : ''
  }`.trim();
  return (
    <div className={classNames}>
      <div>
        <KendoCheckbox
          {..._.omit(
            props,
            'isChecked',
            'label',
            'mandatory',
            'clearErrors',
            'onLabelClick',
          )}
          onChange={internalOnChange}
          checked={isChecked}
        />
        <div>
          {React.isValidElement(label) ? (
            label
          ) : (
            <label
              onClick={onLabelClick}
              className="k-checkbox-label"
              dangerouslySetInnerHTML={{
                __html: label ? `${label}${mandatoryElement}` : '<p></p>',
              }}
            />
          )}
          <ErrorViewer errors={errors} />
        </div>
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
    </div>
  );
}
